<template>
<div>
<courseAttend/>

</div>
</template>
<script>
import courseAttend from "../../components/academic/courseAttend.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
    courseAttend
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>